export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/bookings/service-bookings', 'admin.service-bookings')
    .when('/admin/bookings/service-bookings/:id', 'admin.service-booing-info')
    .when('/admin/bookings/service-bookings/:id/reporting', 'admin.service-booking-reporting')
    .when('/admin/bookings/service-bookings/:id/reassign', 'admin.service-booking-reassign')
    .when('/admin/bookings/parts-orders', 'admin.parts-orders')
    .when('/admin/bookings/parts-orders/:id', 'admin.parts-order-info')

    .within('admin')

    .segment('service-bookings', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.bookings'
      }],
      template: '<admin-service-bookings-page></admin-service-bookings-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-bookings.module" */ "./service-bookings/admin-service-bookings.module");
      }
    })

    .segment('service-booing-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN', isRequest: true},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.bookings',
          url: '/admin/bookings/service-bookings'
        },
        {
          label: 'admin.breadcrumb.service_booking_info'
        }
      ],
      template: '<admin-service-booking-info-page></admin-service-booking-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-booking-info.module" */ "./service-booking-info/admin-service-booking-info.module");
      }
    })

    .segment('service-booking-reporting', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.bookings',
          url: '/admin/bookings/service-bookings',
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
          url: '/admin/bookings/service-bookings/:id',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.booking_reporting',
        }
      ],
      template: '<admin-service-booking-reporting-page></admin-service-booking-reporting-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-booking-reporting.module" */ "./service-booking-reporting/admin-service-booking-reporting.module");
      }
    })

    .segment('service-booking-reassign', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.bookings',
          url: '/admin/bookings/service-bookings',
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
          url: '/admin/bookings/service-bookings/:id',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.booking_reassign',
        }
      ],
      template: '<admin-service-booking-reassign-page></admin-service-booking-reassign-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-service-booking-reassign.module" */ "./service-booking-reassign/admin-service-booking-reassign.module");
      }
    })

    .segment('parts-orders', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.bookings'
      }],
      template: '<admin-parts-orders-page></admin-parts-orders-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-parts-orders.module" */ "./parts-orders/admin-parts-orders.module");
      }
    })
    .segment('parts-order-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.bookings',
          url: '/admin/bookings/parts-orders'
        },
        {
          label: 'admin.breadcrumb.parts_order_info'
        }
      ],
      template: '<admin-parts-order-info-page></admin-parts-order-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-parts-order-info.module" */ "./parts-order-info/admin-parts-order-info.module");
      }
    });
}
